import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_Label = _resolveComponent("Label")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.value)
      ? _createVNode(_component_Button, {
          key: 0,
          checkbox: "",
          "onOn-click": _cache[1] || (_cache[1] = $event => (_ctx.updateValue()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckIcon, { class: "w-4 h-4 text-white" })
          ]),
          _: 1
        })
      : _createCommentVNode("", true),
    (_ctx.value)
      ? _createVNode(_component_Button, {
          key: 1,
          checkbox: "",
          "onOn-click": _cache[2] || (_cache[2] = $event => (_ctx.updateValue())),
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CheckIcon, { class: "w-4 h-4" })
          ]),
          _: 1
        })
      : _createCommentVNode("", true),
    _createVNode(_component_Label, {
      class: "ml-2",
      error: _ctx.error,
      labelId: _ctx.labelId,
      label: _ctx.label
    }, null, 8, ["error", "labelId", "label"])
  ]))
}